module.exports = __webpack_public_path__ + "static/fonts/DINProBold.863da7c2.woff2";